import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Image,
  Row,
  Carousel,
  Modal,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import { IMAGES } from "../../../assets/images/images";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import {
  blockDate,
  EnableDisablePropertys,
  getBlockedDates,
  myProperties,
} from "../../../utility/apiServices/userServices";
import { useNavigate } from "react-router-dom";
import LoaderHome from "../../../components/loader/homeloader";
import { format } from "date-fns";
import { formatDate } from "../../userpanel/propertydetail";
import Swal from "sweetalert2";
import moment from "moment/moment";
import { description, discountMaxPrice, getPriceBasedOnDay } from "../../../utility/local/functions/crypto";
import { useTranslation } from "react-i18next";

const MyProperties = () => {
  const navigate = useNavigate();
  const {t ,i18n} = useTranslation()
  const [searchText, setSearchText] = useState("");
  const [properties, setProperties] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [fetchingProperty, setfetchingProperty] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(null)
  const currentLanguage = i18n.language;

  const getAllMyProperties = async (searchText, page, limit) => {
    try {
      const fetchProperties = await myProperties(searchText, page, limit);
      if (fetchProperties.status) {
        setProperties(fetchProperties?.properties || []);
        setTotalRecords(fetchProperties?.totalResults)
      } else {
        console.error('Failed to fetch properties:', fetchProperties);
        setProperties([]);
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
      setProperties([]);
    }
    setfetchingProperty(false);
  };

  const paginationOptions = {
    rowsPerPageText: t("rowsPerPage"),
    rangeSeparatorText: t("of"), 
  };

  const enableDisableProperty = async (data) => {
    try {
      const confirmation = await Swal.fire({
        title: t("messages.are_you_sure"),
        text:t("messages.enable_disable_property"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, proceed!',
        cancelButtonText: 'Cancel',
      });

      if (confirmation.isConfirmed) {
        const result = await EnableDisablePropertys(data);
        getAllMyProperties(searchText, page, limit);
        Swal.fire({
          title: result.message,
          icon: result.status ? 'success' : 'error',
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      console.error(error, 'CHECK THE ERRORS');
      Swal.fire({
        title: t("messages.error"),
        text: t("messages.something_went_wrong") ,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };


  useEffect(() => {
    const debounceFetchProperties = setTimeout(() => {
      getAllMyProperties(searchText, page, limit);
    }, 500);

    return () => clearTimeout(debounceFetchProperties);
  }, [searchText, page, limit]);

  const columns = [
    {
      name: t("table.property_title"),
      minWidth: "420px",
      selector: (row) => row.short_description,
      sortable: true,
      cell: (row) => (
        <div className="d-flex align-items-center tb_content">
          <span className="propertytable_icon">
            {
              row?.images?.[0]?.room1?.[0]?.location ? (
                <Image alt="" src={row.images[0].room1[0].location} style={currentLanguage === "he" ? {marginLeft:"1.3rem"} :{marginRight:'1.3rem'}} />
              ) : null
            }
          </span>
          <div className="flex-grow-1">
            <h5>{description(row?.short_description ,row?.short_description_hebrew , currentLanguage)}</h5>
            <p>
              <Icon icon="system-uicons:location" />{" "}
              {row?.street_address?.length > 30
                ? row?.street_address.slice(0, 30) + "..."
                : row?.street_address}{" "}
            </p>
            <p className="pColor">
              {row.phone_number}
            </p>
            <h6>${getPriceBasedOnDay(row?.weekdays_discounted_price, row?.weekend_discounted_price)}</h6>
          </div>
        </div>
      ),
    },
    {
      name:  t("table.review"),
      minWidth: "200px",
      selector: (row) => row.reviews,
      sortable: true,
      cell: (row) => (
        <div className="sTarFlex">
          <div className="star-rating">
            {[
              ...Array(row?.averageRating ? Math.floor(row?.averageRating) : 0),
            ].map((_, index) => (
              <div key={index}>
                <Icon icon="ph:star-fill" color="#E1C03F" />
              </div>
            ))}
            {[
              ...Array(
                5 - (row?.averageRating ? Math.floor(row?.averageRating) : 0)
              ),
            ].map((_, index) => (
              <div key={index}>
                <Icon icon="ph:star" color="#E1C03F" />
              </div>
            ))}
          </div>
          <p>
            {row?.averageRating ? Math.floor(row?.averageRating) : 0} (
            {row?.reviewCount ? Math.floor(row?.reviewCount) : 0})
            {row?.averageRating ? (
              <button style={{ border: 'none', outline: 'none', backgroundColor: 'transparent', color: '#1b91bf', fontWeight: '500' }} onClick={() => {
                navigate('/reviewList', {
                  state: { property: row },
                })
              }}>  {t("table.show_reviews")}</button>
            ) : (
              <Link to=""> {t("table.no_reviews")}</Link>
            )}
          </p>
        </div>
      ),
    },
    {
      name:t("table.date_published"),
      selector: (row) => row.createdAt,
      minWidth: "200px",
      sortable: true,
      cell: (row) => <p>{formatDate(row.createdAt)}</p>,
    },
    {
      name:  t("table.views"),
      selector: (row) => row.viewCount,
      sortable: true,
      cell: (row) => <p>{row.viewCount || "0"}</p>,
    },
    {
      name: t("table.availability"),
      selector: (row) => row.is_available_for_booking,
      sortable: true,
      cell: (row) => (
        <Link
          onClick={() => {
            setSelectedProperty(row);
            setModalShow(true);
          }}
          className="editText"
        >
          {row.is_available_for_booking    ? t("table.available")
          : t("table.unavailable")}
        </Link>
      ),
    },
    {
      name: t("table.actions"),
      width: "220px",
      cell: (row) => (
        <div className="actionBtn flexrow" style={{ display: "flex", gap: "8px" }}>
          <div
            className="d-flex align-items-center propertyactionbtn"
            onClick={() => {
              navigate("/discount", { state: { id: row?.id, price: discountMaxPrice(row?.weekdays_discounted_price, row?.weekend_discounted_price) } });
            }}
            title={t("table.manage_discounts") || "Manage Discounts"}
            style={{ cursor: "pointer" }}
          >
            <Icon
              icon="tabler:rosette-discount"
              fontSize={22}
              color="#1B91BF"
            ></Icon>
          </div>
          <div
            className="d-flex align-items-center propertyactionbtn"
            onClick={() => handleEdit(row)}
            title={t("table.edit") || "Edit"}
            style={{ cursor: "pointer" }}
          >
            <Icon icon="bi:pencil-square" fontSize={19} color="#666666"></Icon>
          </div>
          <a
            onClick={() => {
              enableDisableProperty({ propertyId: row?.id });
            }}
            className="btndownload"
            title={row.is_active ? (t("table.disable") || "Disable") : (t("table.enable") || "Enable")}
            style={{ cursor: "pointer" }}
          >
            <Icon icon="ph:trash" fontSize={22} color="#EF3826"></Icon>
          </a>
        </div>
      ),
    },
  ];

  const handleEdit = (property) => {
    navigate("/addpropertyscreen", { state: { propertyData: property } });
  };

  const filteredData = properties.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(searchText.toLowerCase()) !==
      -1
  );

  const [modalShow, setModalShow] = React.useState(false);

  return (
    <React.Fragment>
      <section className="commonpad">
        <Container fluid>
          <Row className="mb-4">
            <Col md={12}>
              <div className="proFlex proFlex1">
                <h2>{t("headings.my_properties")}</h2>
                <Button as={Link} to="/addpropertyscreen">
                  {t("buttons.add_property")}
                </Button>
              </div>
            </Col>
          </Row>

          <Row className="hideDesktop">
            <Col lg={12}>
              <div className="mProperies">
                <div className="inFlx">
                  <Form.Select  
                className={currentLanguage === "he" ? "rtl-dropdown maxwidth120" : "ltr-dropdown maxwidth120"}
                  value={limit} onChange={(e) => setLimit(Number(e.target.value))}>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                  </Form.Select>

                </div>
                <div className="commonSearch mb-3">
                  <Icon icon="bi:search" fontSize={20} color={"#666666"} />
                  <input
                    type="text"
                    placeholder={t("placeholders.search")}
                    className="searchfield"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
              </div>
            </Col>
            {fetchingProperty ? (
              <div className="text-center">
                <span className="spinner "></span>
              </div>
            ) : (
              <>
                {properties && properties.length > 0 ? properties.map((listing) => (
                  <Col key={listing.id} xl={3} lg={4} md={6}>
                    <div className="listing listingMbile">
                      <div className="listImgBox">
                        <Link
                          to="/property-reviews"
                          className="starRating text-decoration-none"
                        >
                          <Icon
                            icon="ph:star-fill"
                            style={{ position: "relative", top: -2 }}
                          />
                          {listing?.reviewCount}
                        </Link>
                        <div className="heartBox heartBox1">
                          <Icon
                            icon="solar:eye-outline"
                            color="#ffffff"
                            fontSize={25}
                          />{" "}
                          {listing?.viewCount}
                        </div>
                      </div>
                      <Carousel data-bs-theme="dark">
                        {
                          listing.images && listing.images.length > 0 && listing.images[0]?.room1 && listing.images[0].room1.map((val, index) => {
                            return <Carousel.Item key={index}>
                              <div
                                className="listImage"
                                style={{ backgroundImage: `url(${val.location})` }}
                              ></div>
                            </Carousel.Item>
                          })
                        }
                      </Carousel>
                      <div className="listing_body">
                        <div className="listing_body_pad">
                          <h2>
                            {" "}
                            {/* {`${listing?.short_description?.length > 35
                              ? listing?.short_description?.slice(0, 35) +
                              "..."
                              : listing?.short_description
                              }`} */}
                              {description(listing?.short_description, listing?.short_description_hebrew, i18n.language , 35)}
                          </h2>
                          <h3>
                            <Icon icon="system-uicons:location" />{" "}
                            {listing?.street_address?.length > 30
                              ? listing?.street_address.slice(0, 30) + "..."
                              : listing?.street_address}
                          </h3>
                        </div>
                        <div className="listing_body_pad listing_body_footer">
                          <h5>${listing.price_for_weekdays}</h5>
                          <div className="actionBtn">
                            <Link
                              className="btndownload"
                              onClick={() => {
                                setSelectedProperty(listing);
                                setModalShow(true);
                              }}
                              title={t("table.block_dates") || "Block Dates"}
                            >
                              <Icon
                                icon="uil:calender"
                                fontSize={22}
                                color="#1B91BF"
                              ></Icon>
                            </Link>
                            <a
                              className="btndownload"
                              onClick={() => {
                                navigate("/discount", { state: { id: listing?.id, price: discountMaxPrice(listing?.weekdays_discounted_price, listing?.weekend_discounted_price) } });
                              }}
                              title={t("table.manage_discounts") || "Manage Discounts"}
                            >
                              <Icon
                                icon="tabler:rosette-discount"
                                fontSize={22}
                                color="#1B91BF"
                              ></Icon>
                            </a>
                            <a
                              href="#"
                              onClick={() => handleEdit(listing)}
                              className="btndownload btndownloadEdit"
                              title={t("table.edit") || "Edit"}
                            >
                              <Icon
                                icon="bi:pencil-square"
                                fontSize={19}
                                color="#666666"
                              ></Icon>
                            </a>
                            <a
                              onClick={() => enableDisableProperty({ propertyId: listing?.id })}
                              className="btndownload"
                              title={listing.is_active ? (t("table.disable") || "Disable") : (t("table.enable") || "Enable")}
                            >
                              <Icon
                                icon="ph:trash"
                                fontSize={22}
                                color="#EF3826"
                              ></Icon>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                )) : (
                  <Col md={12}>
                    <div className="text-center py-5">
                      <p>{t("messages.no_properties_found") || "No properties found"}</p>
                    </div>
                  </Col>
                )}
              </>
            )}
          </Row>

          <Row className="hideMobile">
            <Col lg={12}>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              {fetchingProperty ? (
                <div className="text-center d-flex justify-content-center">
                  <LoaderHome />
                </div>
              ) : (
                <DataTable
                  columns={columns}
                  data={properties}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRecords}
                  paginationComponentOptions={paginationOptions}
                  onChangePage={(newPage) => setPage(newPage)}
                  onChangeRowsPerPage={(newLimit) => {
                    setLimit((prev) => {
                      if (prev !== newLimit) {
                        setPage(1);
                      }
                      return newLimit;
                    });
                  }}
                  progressPending={loading}
                  noHeader
                  responsive
                  className="tableDataTable"
                />
              )}
            </Col>
          </Row>
        </Container>
      </section>
      <BookingDateModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        t={t}
        property={selectedProperty}
        callData={() => {
          getAllMyProperties(searchText)
        }}
      />
    </React.Fragment>
  );
};

function BookingDateModal({ show, onHide, property, callData , t}) {
  const [date, setDate] = useState(new Date());
  const [blockedDates, setBlockedDates] = useState([]);

  const onChange = (newDate) => {
    setDate(newDate);
  };

  useEffect(() => {
    if (property) {
      const fetchBlockedDates = async () => {
        try {
          const response = await getBlockedDates(property?.id);
          if (response.status) {
            setBlockedDates(response?.blockDates);
          }
        } catch (error) {
          console.error("Error fetching blocked dates:", error);
        }
      };

      fetchBlockedDates();
    }
  }, [property]);

  const handleBlockDate = async () => {
    try {
      const response = await blockDate({
        propertyId: property.id,
        date: format(date, "yyyy-MM-dd"),
      });
      if (response.status) {
        if (response.isadded) {
          setBlockedDates((prevDates) => [
            ...prevDates,
            response?.newBlockDate,
          ]);
          Swal.fire({
            title: t("headings.block_bookings_dates"),
            text: t("messages.date_blocked_successfully"),
            icon: "success",
            confirmButtonText: "OK",
          });
          callData()
          onHide()
        } else {
          setBlockedDates((prevDates) =>
            prevDates.filter((blockedDate) => {
              return blockedDate.date !== format(date, "yyyy-MM-dd");
            })
          );
          Swal.fire({
            title: t("headings.block_bookings_dates"),
            text: t("messages.date_unblocked_successfully"),
            icon: "success",
            confirmButtonText: "OK",
          });
          callData()
          onHide()
        }
      } else {
        onHide()
      }

    } catch (error) {
      console.error("Error blocking date:", error);
    }
  };

  const isBlocked = (date) => {
    const currentDateString = moment(date).format('YYYY-MM-DD');
    return blockedDates.some((blockedDate) => {
      const blockedDateString = moment(blockedDate.date).format('YYYY-MM-DD');
      return currentDateString === blockedDateString;
    });
  };


  function isToday(date) {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }


  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body
        style={{
          maxHeight: "calc(100vh - 50px)",
          overflowY: "auto",
        }}
      >
        <h2 className="text-center">{t("headings.block_bookings_dates")}</h2>

        <div className="calenderBox">
          <Calendar
            onChange={onChange}
            value={date}
            minDate={new Date()}
            tileClassName={({ date, view }) => {
              if (isBlocked(date)) {
                return "blockeddate";
              }
              return null;
            }}
          />


        </div>

        <div className="dateFlexBlock">
          <h3 className="h31">
            <span></span>
            {t("messages.select_block_dates")}
          </h3>
          <h3 className="h32">
            <span></span>
            {t("messages.booked")}
          </h3>
        </div>
        <div className="blocFlex">
          <Button variant="outline-primary" onClick={onHide}>
          {t("buttons.cancel")}
          </Button>
          <Button onClick={() => handleBlockDate()}>   {isBlocked(date)
              ? t("buttons.unblock_selected_dates")
              : t("buttons.block_selected_dates")}  </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default MyProperties;
